import React from 'react';
import { SALES_TABS, SALES_NAV_TABS } from '../utils/salesTabs';
import StartLockedDepartmentPage from '../components/start/StartLockedDepartmentPage';

/**
 * Locked preview of the portal Sales hub (/portal/sales) for /start prospects.
 *
 * Close Ratio folded into the portal's Analytics tab, so that grant unlocks the
 * standalone /start Close Ratio page that still backs it. The Materials tab
 * unlocks for the Sales Materials grant (item-level, unlockedSalesMaterials)
 * and still honors the legacy Partner Programs grant.
 */
const SALES_UNLOCKS = {
  analytics: { freePage: 'sales/close-ratio', to: '/start/sales/close-ratio' },
  proposals: { freePage: 'sales-proposals', to: '/start/sales/proposals' },
  resources: [
    { freePage: 'sales/resources', to: '/start/sales/resources' },
    { freePage: 'sales-referral-programs', to: '/start/sales-referral-programs' },
  ],
};

const StartSales = () => (
  <StartLockedDepartmentPage
    title="Sales"
    tabs={SALES_NAV_TABS}
    allTabs={SALES_TABS}
    unlockMap={SALES_UNLOCKS}
  />
);

export default StartSales;
